import {TextField} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {Filter} from '../../filter.types'

import {commonFilterSx} from './styles'

interface TextSearchFilterProps extends Filter<string> {
  translationNamespace?: string
}

export const TextSearchFilter: React.FC<TextSearchFilterProps> = ({
  id,
  label,
  value,
  handleChange,
  translationNamespace
}) => {
  const {t} = useTranslation(translationNamespace)
  return (
    <TextField
      data-test-id={`textsearch-${id}`}
      type="text"
      value={value}
      onChange={handleChange}
      inputProps={{maxLength: 50}}
      InputProps={{sx: {height: '58px'}}}
      variant="filled"
      label={t(label)}
      placeholder={'search'}
      sx={commonFilterSx}
      fullWidth
    />
  )
}
